<template>
	<form class="servicefinder-location-form" method="POST" :action="servicefinder.mapPageUrl">
		<div class="wp-block-columns is-layout-flex">
			<div class="wp-block-column">
				<input type="text" id="address" :placeholder="servicefinder.labels.placeholder" v-model="maps.address">
			</div>

			<div class="wp-block-column" style="flex-basis: auto;">
				<div class="wp-block-buttons">
					<div class="wp-block-button">
						<input type="submit" class="wp-block-button__link has-medium-font-size" :value="servicefinder.labels.search" @click="submitForm"></a>
					</div>
				</div>
			</div>
		</div>

		<input type="hidden" name="lat" :value="lat"/>
		<input type="hidden" name="lng" :value="lng"/>
		<input type="hidden" name="address" :value="maps.address"/>
		<input type="hidden" name="action" value="servicefinder"/>
	</form>
</template>

<script>
	export default {
		data() {
			return {
				query: {
					lat: null,
					lng: null,
					radius: 100
				}
			}
		},

		computed: {
			lat() {
				return this.maps.location && this.maps.location.lat ? this.maps.location.lat : '';
			},

			lng() {
				return this.maps.location && this.maps.location.lng ? this.maps.location.lng : '';
			},

			radius() {
				return this.maps.location && this.maps.location.radius ? this.maps.location.radius : 100;
			}
		},

		watch: {},

		created() {
			//Link to servicefinder data
			this.servicefinder = window.servicefinder;
		},

		mounted() {
			this.initGoogleAutocomplete();
		},

		methods: {
			initGoogleAutocomplete() {
				$.getScript(servicefinder.apiUrl, () => {
		            //Init the autocomplete
		            let addressField = document.getElementById('address');

		            //Submit on enter
		            this.pacSelectFirst(addressField);

		            //Init
		            this.maps.autocomplete = new google.maps.places.Autocomplete(
		                addressField,
		                {
		                    componentRestrictions: {'country': 'ca'},
		                    fields: ['formatted_address', 'geometry', 'place_id']
		                }
		            );

		            //Listen for address change
		            this.maps.autocomplete.addListener('place_changed', ((e) => {
		                let place = this.maps.autocomplete.getPlace();

		                if (place) {
		                	this.navigateToLocation(place.geometry.location.lat(), place.geometry.location.lng(), place.formatted_address, 10);
		                }
		            }));
				});
			},

			submitForm() {
				$('.servicefinder-location-form').submit();
			}
		},
	}
</script>
